import { render, staticRenderFns } from "./BpCashInBankNumberDisplayer.vue?vue&type=template&id=36a01739"
import script from "./BpCashInBankNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpCashInBankNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports